// Lightgallery jquery version! https://github.com/sachinchoolur/lg-video
// Not lightgallery.js because it gave errors.

$('.c-media__video-preview video').each(function () {
    let $this = $(this);
    let video = $this.get(0);
    let timeToReset = 10;
    let hasReset = $this.parent().data('loop');

    if (hasReset === 1) {
        setInterval(() => {
            let videoCurrentTime = Math.ceil(video.currentTime);
            if (videoCurrentTime > timeToReset) {
                video.currentTime = 0;
            }
        }, 1000);
    }
});



// WEBPACK FOOTER //
// ./scripts/routes/components/media.js